import { render } from "./HandheldDatastream.vue?vue&type=template&id=45dba868"
import script from "./HandheldDatastream.vue?vue&type=script&lang=js"
export * from "./HandheldDatastream.vue?vue&type=script&lang=js"

import "./HandheldDatastream.vue?vue&type=style&index=0&id=45dba868&lang=scss"
script.render = render

export default script